<template>
    <div v-if='!overlapping' class='container-planning'
        :class='{ six: size === 6, twelve: size === 12, three: size === 3 }'>
        <div class="today-rule" :style='todayStyles'></div>
        <router-link class="affectation" v-for="(affectation, index) in affectations"
            target="_blank"
            :key='index' :style='styles(affectation)'
                     :to="{ name: getRouteName(affectation),
                     params:{ id: getIdRouterLink(affectation) }}"
                     :class="{'text-access-no-permission' :
                     !checkPermissions(getPermissions(affectation.typeReference))}">
            <div class='libelle' :class="{'has-text-white' :
                     checkPermissions(getPermissions(affectation.typeReference))}">
              {{ getLibelleAffectation(affectation) }}
            </div>
        </router-link>
    </div>
    <div :style="`--amount:${affectations.length}`" v-else>
      <div class='container-planning multiline'
        v-for="affectation in affectations" :key='affectation.referenceId'
        :class='{ six: size === 6, twelve: size === 12, three: size === 3 }'>
        <div class="today-rule" :style='todayStyles'></div>
        <router-link class="affectation" target="_blank"
                     :style='styles(affectation)'
                     :to="{ name: getRouteName(affectation),
                     params:{ id: getIdRouterLink(affectation) }}"
                     :class="{'text-access-no-permission' :
                     !checkPermissions(getPermissions(affectation.typeReference))}">
          <div class='libelle' :class="{'has-text-white' :
                     checkPermissions(getPermissions(affectation.typeReference))}">
            {{ getLibelleAffectation(affectation) }}
          </div>
        </router-link>
      </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import { COMMANDES, CATALOGUE } from '@/configuration/permissionsBodacConf';
import { CATEGORIE_REGROUPEMENT_LC } from '@/configuration/catalogue/produitConf';

const produitFace = createNamespacedHelpers('produitFace');
const produitReseauLc = createNamespacedHelpers('produitReseauLc');
const permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'c_decorationPeriodeFaceUnitaireReseauLc',
  props: ['data', 'index'],
  data() {
    return {
      permCommande: COMMANDES,
      permCatalogue: CATALOGUE,
    };
  },
  methods: {
    ...permissions.mapActions(['showPopup']),
    getLibelleAffectation(affectation) {
      let libelle = affectation.libelle;
      if (affectation.reconductible) libelle += this.$i18n.t('detailsPlanningFaceUnitaire.tab.rt');
      if (affectation.societeId !== this.societeActiveId
        && this.getRouteName(affectation) !== 'c.bodac.commandes-venteInterne') {
        const societeFind = this.societesInformations.find((s) => {
          return s.id === affectation.societeId;
        });
        if (societeFind) libelle += (' / ' + societeFind.libelle);
      }
      if (affectation.typeProduit === CATEGORIE_REGROUPEMENT_LC
      && affectation.quantiteDispo !== null && ![0, 1].includes(affectation.quantiteDispo)) {
        libelle += `- (${affectation.quantiteDispo * 100}%)`;
      }
      return libelle;
    },
    getPermissions(type) {
      if (type === 'Reseau') {
        return this.permCatalogue.lecture;
      }
      return this.permCommande.lecture;
    },
    getRouteName(affectation) {
      let routeName = 'c.bodac.commandes';
      if (affectation.typeReference === 'Reseau') {
        if (affectation.sousTypeReference === 'RegroupementLc') {
          routeName = 'c.bodac.catalogue-reseauLc';
        } else {
          routeName = 'c.bodac.catalogue-reseau';
        }
      }
      if (affectation.commandeInterne
        && affectation.commandeInterne.societeId === this.societeActiveId) {
        routeName = 'c.bodac.commandes-venteInterne';
      }
      return routeName;
    },
    getIdRouterLink(affectation) {
      if (this.getRouteName(affectation) === 'c.bodac.commandes-venteInterne') {
        return affectation.commandeInterne.id;
      } return affectation.referenceId;
    },
    hasOverlapingDates(affectations, defaultDate) {
      if (!defaultDate) throw new Error('Default date needed');
      if (affectations.length === 1) return false;
      const dates = affectations.map(a => {
        return {
          start: moment(a.dureeAffectation.dateDebut, 'DD/MM/YYYY').toDate(),
          end: a.dureeAffectation.dateFin
            ? moment(a.dureeAffectation.dateFin, 'DD/MM/YYYY').toDate() : moment(defaultDate).toDate(),
        };
      });
      let overlapping = false;
      for (let i = 0; i < dates.length; i += 1) {
        const current = dates[i];
        const isOverlapping = dates.some((d, index) => {
          return i === index ? false
            : (moment(current.start).isBetween(d.start, d.end, null, '[]'))
            || (moment(current.end).isBetween(d.start, d.end, null, '[]'));
        });
        if (isOverlapping) {
          overlapping = true;
          break;
        }
      }
      return overlapping;
    },
    styles(affectation) {
      const total = +moment.duration(moment(affectation.viewEnd)
        .diff(affectation.viewStart)).asSeconds().toFixed(3);
      const start = moment.duration(moment(affectation.effectiveStart)
        .diff(moment(this.fromDate))).asSeconds();
      const end = moment.duration(moment(this.toDate)
        .diff(moment(affectation.effectiveEnd))).asSeconds();
      const left = Number(start * 100 / total).toFixed(3);
      const right = Number(end * 100 / total).toFixed(3);
      let radius = '0 0 0 0';
      const radiusValue = '1rem';
      if (!affectation.startCut && !affectation.endCut) {
        radius = `${radiusValue} ${radiusValue} ${radiusValue} ${radiusValue}`;
      } else if (!affectation.startCut) {
        radius = `${radiusValue} 0 0 ${radiusValue}`;
      } else if (!affectation.endCut) {
        radius = `0 ${radiusValue} ${radiusValue} 0`;
      }
      return `left: ${left}%; right: ${right}%; border-radius: ${radius};`;
    },
  },
  computed: {
    ...permissions.mapGetters(['checkPermissions']),
    ...produitFace.mapGetters(['planningFaceUnitaire']),
    ...produitReseauLc.mapGetters(['planningReseauLc']),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
      societeActiveId: 'societeActiveId',
    }),
    affectations() {
      const overlapping = this.hasOverlapingDates(this.data.affectations, this.toDate);
      return this.data.affectations.map(affectation => {
        const start = affectation.dureeAffectation.dateDebut
          ? moment(affectation.dureeAffectation.dateDebut, 'DD/MM/YYYY').toDate()
          : moment(this.fromDate).toDate();
        const end = affectation.dureeAffectation.dateFin
          ? moment(affectation.dureeAffectation.dateFin, 'DD/MM/YYYY').toDate()
          : moment(this.toDate).toDate();
        const viewStart = this.fromDate;
        const viewEnd = this.toDate;
        let startCut = false;
        let endCut = false;
        let effectiveStart = null;
        let effectiveEnd = null;
        if (moment(start).isBefore(viewStart)) {
          effectiveStart = moment(viewStart).toDate();
          startCut = true;
        } else {
          effectiveStart = start;
        }
        if (moment(end).isAfter(viewEnd)) {
          effectiveEnd = moment(viewEnd).toDate();
          endCut = true;
        } else {
          effectiveEnd = end;
        }
        return {
          start,
          end,
          viewStart,
          viewEnd,
          libelle: affectation.libelle,
          reconductible: affectation.reconductible,
          effectiveStart,
          effectiveEnd,
          startCut,
          endCut,
          overlapping,
          typeReference: affectation.typeReference,
          referenceId: affectation.referenceId,
          sousTypeReference: affectation.sousTypeReference,
          societeId: affectation.societeId,
          commandeInterne: affectation.commandeInterne,
          typeProduit: affectation.typeProduit,
          quantiteDispo: affectation.quantiteDispo,
        };
      });
    },
    overlapping() {
      return this.affectations.length ? this.affectations[0].overlapping : false;
    },
    todayStyles() {
      const total = moment.duration(moment(this.toDate).endOf('day').diff(moment(this.fromDate).startOf('day'))).asSeconds();
      const today = moment.duration(moment().endOf('day').diff(moment(this.fromDate).startOf('day'))).asSeconds();
      const left = (today * 100 / total);
      return `left: ${left}%;`;
    },
    isProduitLc() {
      return this.$route.name === 'c.bodac.commandes-planningReseauLc';
    },
    size() {
      return this.isProduitLc ? this.planningReseauLc.months : this.planningFaceUnitaire.months;
    },
    fromDate() {
      return moment(this.isProduitLc ? this.planningReseauLc.fromDate : this.planningFaceUnitaire.fromDate).startOf('day').toDate();
    },
    toDate() {
      return moment(this.isProduitLc ? this.planningReseauLc.toDate : this.planningFaceUnitaire.toDate).endOf('day').toDate();
    },
  },
};
</script>
